import { MissionEventHandler } from "../mission"
import { formatNumber } from "../utils"

export default class SignalLines extends MissionEventHandler {
	grsMapLines = {}
	arsLine = null
	addedLayer = false

	constructor(mission, parentLayer) {
		super(mission)

		this.addedLayer = true
		this.lineLayer = L.layerGroup()
		this.lineLayer.addTo(mymap)
		this.overlay = addOverlay("Signal Lines", this.lineLayer, parentLayer)
	}

	get areAllLinesRendered() {
		return this.arsLine && Object.keys(this.grsMapLines).length >= this.mission.serverState.grsDeviceIds.length
	}

	handleMissionIndexJump(targetIndex) {
		this.clearLines()

		let i = targetIndex
		while (!this.areAllLinesRendered && i > 0 && i > targetIndex - 100) {
			const message = this.mission.history[i]
			if (message.type === 'SKYLINK_ADV_STATUS') {
				this.processStatus(message)
			}
			i--
		}
	}

	processStatus(message) {
		const deviceId = message.data.localSource.deviceId
		let line = this.grsMapLines[deviceId]

		if (message.data.remote.protocol.radioStatus === 0 || 
			message.data.remote.position.latitude === 0) return

		const rssi = Math.max(message.data.local.radio[0].avgRSSI, message.data.local.radio[1].avgRSSI)
		let color
		if (rssi > -75) {
			color = "#00cc00"
		} else if (rssi < -90) {
			color = "#cc0000"
		} else {
			color = "#cccc00"
		}
		const latLngs = [
			[message.data.local.position.latitude, message.data.local.position.longitude],
			[message.data.remote.position.latitude, message.data.remote.position.longitude],
		]
		if (!line) {
			line = L.polyline(latLngs, {
				className: 'radioLine',
				color
			}).addTo(this.lineLayer)
			line.bindTooltip('0.000', {
				permanent: true,
				offset: [0, 0],
				className: "lineLabel",
				direction: "center"
			}, this.lineLayer)
			line.openTooltip()
			this.grsMapLines[deviceId] = line
		} else {
			line.setLatLngs(latLngs)
			line.setStyle({ color })
			line.setTooltipContent(formatNumber(rssi, 2))
			line.openTooltip()
		}

		if (message.data.local.isLead) {
			// Draw the ARS receive line
			const grsPt = mymap.latLngToLayerPoint(latLngs[0])
			const arsPt = mymap.latLngToLayerPoint(latLngs[1])
			const shiftAmount = 5
			const vec = [arsPt.x - grsPt.x, arsPt.y - grsPt.y]
			const direction = Math.atan2(vec[1], vec[0]) + Math.PI / 2
			const shiftX = Math.cos(direction) * shiftAmount
			const shiftY = Math.sin(direction) * shiftAmount
			const latLon = [mymap.layerPointToLatLng([grsPt.x + shiftX, grsPt.y + shiftY]), mymap.layerPointToLatLng([arsPt.x + shiftX, arsPt.y + shiftY])]

			if (!this.arsLine) {
				this.arsLine = L.polyline(latLon, {
					color: "blue",
					className: "radioLine arsRadioLine"
				})
				this.arsLine.addTo(this.lineLayer)
			} else {
				this.arsLine.setLatLngs(latLon)
			}
		}
	}

	handleMissionStep(message) {
		if (message.type == 'SKYLINK_ADV_STATUS') {
			this.processStatus(message)
		}
	}

	clearLines() {
		if (this.arsLine) this.arsLine.removeFrom(this.lineLayer)
		for (const deviceId in this.grsMapLines) {
			this.grsMapLines[deviceId].removeFrom(this.lineLayer)
		}
		this.arsLine = null
		this.grsMapLines = {}
	}

	cleanup() {
		super.cleanup()
		if (this.addedLayer) {
			this.lineLayer.removeFrom(mymap)
			removeOverlay(this.overlay)
		}
	}
}